import GenericAlert from './GenericAlert';

export default GenericAlert;
